//  This document handles the logic for the wishlist and the hearts
//  The logic makes uses of the API of the IWish (app) when the user is logged in and makes use of hte loacalStorage whne the user is not logged in. 
//  There for there are 2 ways of adding and removing products from the wishlist
//  If the user is logged in the window.CUSTOMER.id is filled. 

const fetchProductCardHTML = (handle) => {
    return fetch(handle)
        .then((res) => res.text())
        .then((res) => {
            const text = res;
            const parser = new DOMParser();
            const htmlDocument = parser.parseFromString(text, 'text/html');
            const productCardWrapper = document.createElement('div');
            productCardWrapper.className = "grid__item";
            const productCard = htmlDocument.documentElement.querySelector('.product-card');
            productCardWrapper.appendChild(productCard);
            return productCardWrapper.outerHTML;
        })
        .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};
async function createWishlistCards(result) {
    let productHandles = [];
    result.forEach(item => {
        productHandles.push(`/products/${item.handle}?view=card&variant=${item.variant.id}`)
    })
    const requests = productHandles.map(fetchProductCardHTML);
    const responses = await Promise.all(requests);
    const wishlistProductCards = responses.join('');
    document.querySelector('#wishlist-container').innerHTML = wishlistProductCards;
}
if (window.CUSTOMER && window.CUSTOMER.id) {
    const url = `https://api.myshopapps.com/wishlist/V1/${"fetchWishlistData/" + window.CUSTOMER.id}/`;
    const options = {
        method: 'POST',
        headers: {
            xtoken: 'IWISH_API_6204437fe95811ef8eca0e72f2521631',
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json'
        }
    };
    try {
        const response = await fetch(url, options);
        const data = await response.json();
        localStorage.setItem('iWishlistmain', JSON.stringify(data.result))
        if (document.querySelector('#wishlist-container')) createWishlistCards(data.result);
        if (data.result.length > 0) {
            document.querySelector('.header__nav-icon-wish-span').removeAttribute('hidden');
            document.querySelector('.header__nav-icon-wish-span').innerHTML = data.result.length;
        } else {
            document.querySelector('.header__nav-icon-wish-span').setAttribute('hidden', '')
        }
    } catch (error) {
        console.error(error);
    }
} else {
    if (JSON.parse(localStorage.getItem('iWishlistmainNotLoggedin')) && JSON.parse(localStorage.getItem('iWishlistmainNotLoggedin')).length > 0) {
        if (document.querySelector('#wishlist-container')) createWishlistCards(JSON.parse(localStorage.getItem('iWishlistmainNotLoggedin')));
        document.querySelector('.header__nav-icon-wish-span').removeAttribute('hidden');
        document.querySelector('.header__nav-icon-wish-span').innerHTML = JSON.parse(localStorage.getItem('iWishlistmainNotLoggedin')).length
        } else {
            document.querySelector('.header__nav-icon-wish-span').setAttribute('hidden', '')
        }
}


// handle the hearts for add and remove the product to or from the wishlist
// there are two functions for adding and deleting products. 
//          - One that sets and removes the events (removeToWishlistEvent() and addToWishlistEvent()) and 
//          - one that does the actual logic (handleRemoveFromWishlist, handleAddToWishlist)
// For the logic on the PPD we need to add and delete from wishlist
// For product card we need to open the drawer or remove from wishlist
// For drawer we can only add to wishlist

class WishHeart extends HTMLElement {
    constructor() {
        super();
        if(this.closest("product-card")) this.banner = this.closest("product-card").querySelector('.add-to-wish-banner')
        document.addEventListener('variant:change', (e) =>{
                if(e.detail.product.id == this.dataset.productId) {
                    this.setAttribute('data-variant-id', e.detail.variant.id);
                    this.init();
                }
            });
        this.init();
    }

    async handleFetch(event, product_id, variant_id) {
        const url = `https://api.myshopapps.com/wishlist/V1/${event}/`;
        const options = {
            method: 'POST',
            headers: {
                xtoken: 'IWISH_API_6204437fe95811ef8eca0e72f2521631',
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json'
            },
            body: new URLSearchParams({ customer_id: Number(window.CUSTOMER.id), product_id, variant_id })
        };
        try {
            const response = await fetch(url, options);
            const data = await response.json();
            if(event == 'addToWishlist') {
                this.handleAddLocalStorage('iWishlistmain')
            } else {
                this.handleRemoveLocalStorage('iWishlistmain')
            }
        } catch (error) {
            console.error(error);
        }
    }

    handleAddLocalStorage(name) {
        const localStorageData = JSON.parse(localStorage.getItem(name));
        const newItem = {
            id: this.dataset.productId,
            handle: this.dataset.handle,
            variant: {
                id: this.dataset.variantId
            }
        }
        let newLocalStorageData = []
        if(localStorageData){
            newLocalStorageData = localStorageData.concat(newItem)
        }else {
            newLocalStorageData = [newItem]
        }
        localStorage.setItem(name, JSON.stringify(newLocalStorageData))
        this.updateSpanNumber(JSON.parse(localStorage.getItem(name)).length)
    }

    handleRemoveLocalStorage(name) {
        const localStorageData = JSON.parse(localStorage.getItem(name));
        let updatedArray = localStorageData.filter((obj) => obj.id != this.dataset.productId);
        if(this.classList.contains('wish-heart_product-info')) updatedArray = localStorageData.filter((obj) => obj.variant.id != this.dataset.variantId);
        localStorage.setItem(name, JSON.stringify(updatedArray))
        this.updateSpanNumber(JSON.parse(localStorage.getItem(name)).length)
    }

    updateSpanNumber(length) {
        const spanNumber = document.querySelector('.header__nav-icon-wish-span')
        spanNumber.innerText = length;
        
        if (length > 0) {
            spanNumber.removeAttribute('hidden');
        } else {
            spanNumber.setAttribute('hidden', '');
        }
    }

    addToWishlistEvent() {
        if(this.classList.contains('wish-heart-product_card') && this.closest("product-card") && this.closest("product-card").querySelector('quick-buy-drawer')){
            this.addEventListener('click', this.openDrawer);
        } else {
            this.addEventListener('click', this.handleAddToWishlist);
            this.removeEventListener('click', this.handleRemoveFromWishlist);
        }
    }

    openDrawer() {
        this.closest("product-card").querySelector('quick-buy-drawer').classList.add('wish-drawer');
        this.closest("product-card").querySelector('quick-buy-drawer').show();
    }

    removeToWishlistEvent() {
        this.addEventListener('click', this.handleRemoveFromWishlist);
        this.removeEventListener('click', this.handleAddToWishlist);
    }
    
    handleAddToWishlist = async () => {
        if (window.CUSTOMER && window.CUSTOMER.id) {
            await this.handleFetch("addToWishlist", Number(this.dataset.productId), Number(this.dataset.variantId));
        } else {
            this.handleAddLocalStorage('iWishlistmainNotLoggedin');
        }
    
        document.querySelectorAll(`wish-heart.heart-icon[data-handle="${this.getAttribute('data-handle')}"]`).forEach(heart => heart.querySelector('svg').style.fill = "#000");
    
        if (this.closest("quick-buy-drawer")) {
            this.closest("quick-buy-drawer").hide();
            const heartOnCard = document.querySelector(`wish-heart[data-product-id="${this.dataset.productId}"]`);
            await heartOnCard.init();
            heartOnCard.removeEventListener('click', heartOnCard.openDrawer);
        } else {
            this.removeToWishlistEvent();
        }
    };
    
    handleRemoveFromWishlist = () => {
        if(window.CUSTOMER && window.CUSTOMER.id){
            this.handleFetch("removeWishlist", Number(this.dataset.productId), Number(this.dataset.variantId))
        } else {
            this.handleRemoveLocalStorage('iWishlistmainNotLoggedin');
        } 
        document.querySelectorAll(`wish-heart.heart-icon[data-handle="${this.getAttribute('data-handle')}"]`).forEach(heart => heart.querySelector('svg').style.fill = "none" )

        if (this.banner) this.banner.style.display = "none";
        if (document.querySelector('#wishlist-container')) this.closest('.grid__item').remove();
        this.addToWishlistEvent();
    };

    init() {
        let iWishlistmain;
        if(window.CUSTOMER && window.CUSTOMER.id){
            iWishlistmain = localStorage.getItem('iWishlistmain')
        } else {
            iWishlistmain = localStorage.getItem('iWishlistmainNotLoggedin');
        } 

        let productWish; 
        if(JSON.parse(iWishlistmain) && !this.classList.contains('wish-heart_product-info')) {
            const wishlistItems = JSON.parse(iWishlistmain);
            productWish = wishlistItems.find(obj => obj.id === this.dataset.productId);
            if (productWish) {
                this.dataset.variantId = productWish.variant.id;
            }
        }
        if(JSON.parse(iWishlistmain) && this.classList.contains('wish-heart_product-info')) productWish = JSON.parse(iWishlistmain).some(obj => obj.variant.id === this.dataset.variantId);

        if(iWishlistmain && productWish) {
            this.removeToWishlistEvent();
            if(this.querySelector('svg')) this.querySelector('svg').style.fill = "#000";
        } else {
            this.addToWishlistEvent();
            if(this.querySelector('svg')) this.querySelector('svg').style.fill = "none";
        }
    }
}

customElements.define('wish-heart', WishHeart);
